import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { fetchUserById } from '@/features/profile/api';
import { getCurrentUserId } from '@/features/auth/session';
import type { UserProfile } from '@/features/profile/types';

/**
 * Fetch a user profile from `/userservice/api/v3/user/:userId`.
 * Pass no argument (or omit) to fetch the currently logged-in user's profile.
 */
export function useUserProfileQuery(userId?: string | number) {
  const resolvedId = userId ?? getCurrentUserId() ?? '';

  return useQuery<UserProfile>({
    queryKey: queryKeys.profile.byId(resolvedId),
    queryFn: () => fetchUserById(resolvedId),
    enabled: Boolean(resolvedId),
    staleTime: 60_000,
  });
}
